import { Component } from "react";
import * as React from "react";
import { stylesheet } from "typestyle";
import * as ErrorStackParser from "error-stack-parser";
import { layout } from "./layout.js";
import { MessageView } from "./MessageView.js";
import { classNames } from "./utils.js";
import { typography } from "./typography.js";
import { PushButton } from "./PushButton.js";
export class AppErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.handleRestart = () => location.reload();
        this.state = {};
    }
    componentDidCatch(error, errorInfo) {
        console.error('AppErrorBoundary:: an error occurred in the app', error);
        console.error('AppErrorBoundary:: error info', errorInfo);
        this.setState({
            error,
            errorInfo
        });
        const errorContext = {
            url: location.href,
            referrer: document.referrer,
            userAgent: navigator.userAgent,
            error
        };
        this.reportBugsnag(errorContext)
            .catch(err => console.error('failed to report to bugsnag', err));
    }
    async reportBugsnag(errorContext) {
        const { appId, cubeId } = this.props;
        const { error, url, referrer, userAgent } = errorContext;
        const stackTraces = ErrorStackParser.parse(error)
            .map(({ fileName: file, lineNumber, columnNumber, functionName: method }) => ({
            file,
            lineNumber,
            columnNumber,
            method
        }));
        const payload = {
            apiKey: "d1289293566bd660bd5407add4182dba",
            payloadVersion: '5',
            notifier: {
                name: `app-host - ${cubeId} - ${appId}`,
                version: '1.0.11',
                url: 'https://github.com'
            },
            events: [
                {
                    exceptions: [{
                            errorClass: error.message,
                            stacktrace: stackTraces,
                            type: 'browserjs'
                        }],
                    request: {
                        httpMethod: '',
                        url,
                        referrer
                    },
                    user: {
                        id: 'app-host'
                    },
                    metaData: {
                        userAgent: { userAgent },
                        sessionStorage: sessionStorage,
                        localStorage: localStorage
                    }
                }
            ]
        };
        try {
            const response = await fetch('https://notify.bugsnag.com/', {
                method: 'POST',
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                console.info('successfully reported error to bugsnag');
            }
        }
        catch (error) {
            console.log('failed to report error to bugsnag', error);
        }
    }
    render() {
        var _a;
        if (this.state.error) {
            return (React.createElement(MessageView, { message: "An internal error occurred.", className: styles.messageView },
                React.createElement("div", { className: layout.vertical },
                    React.createElement("div", null, `${this.state.error}`),
                    React.createElement("div", { className: classNames(typography.muted, typography.smaller) }, (_a = this.state.errorInfo) === null || _a === void 0 ? void 0 : _a.componentStack),
                    React.createElement(PushButton, { primary: true, onClick: this.handleRestart }, "Restart"))));
        }
        return this.props.children;
    }
}
const styles = stylesheet({
    messageView: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%"
    }
});
//# sourceMappingURL=AppErrorBoundary.js.map